import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { sectionUc } from '../../../actions/section';
import UcChoose from './UcChoose';
import UcWatch from './UcWatch';
import UcTrack from './UcTrack';
import UcPic from './UcPic';
import { shadowSize } from '../../../utils/utils';

export class Uc extends React.Component {
	componentDidMount() {
		this.props.sectionUc();
		shadowSize();
	}
	render() {
        return (
			<div id="uc" className="char section">
			    <UcChoose />
			    <UcWatch />
			    <UcTrack />
			    <UcPic />
			</div>
		);
    }
};

const mapDispatchToProps = (dispatch) => ({
	sectionUc: () => dispatch(sectionUc())
});

export default connect(undefined, mapDispatchToProps)(Uc);



// WEBPACK FOOTER //
// ./src/components/sections/uc/Uc.js